// src/shell/appStore.ts
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AppStore {
  activeAppId: string | null
  setActiveApp: (id: string) => void
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      activeAppId: null,
      setActiveApp: (id: string) => set({ activeAppId: id }),
    }),
    {
      name: 'otia-active-app',
    },
  ),
)
